<template lang="pug">
  article.article-item(:class="position")
    .jumbo
      .mask
        img(:src="getImage(image)")
        //- VideoPlayer(v-if="config.jumbo.video" :video="config.jumbo.video")
    .wrap
      header
        h2.title
          small.firstname {{firstname}}
          span.lastname {{lastname}}
        p.data
          span.age {{age}}
          span.city {{city}}
        .playwrap
          PlayButton.playbutton
      .arrow
        font-awesome-icon.icon(v-if="position === 'even'" :icon="['fa', 'long-arrow-alt-left']")
        font-awesome-icon.icon(v-if="position === 'odd'" :icon="['fa', 'long-arrow-alt-right']")
      .description
        //- .logo-description
        //-   h2.title
        //-     small.firstname {{firstname}}
        //-     span.lastname {{lastname}}
        .wrap-description
          h4 {{prizetitle}}
          p.prize
            strong Tipo de emprendimiento y  premio obtenido:
            span  {{prize}}
          p.capital
            strong Capital inicial y año de comienzo del emprendimiento:
            span  {{capital}}
          p.employees
            strong Número de empleados:
            span  {{employees}}
          p.lesson
            strong Lección Emprendedora:
            span  {{lesson}}

</template>
<script>
import PlayButton from '@/components/PlayButton'

export default {
  components: {
    PlayButton
  },
  props: {
    firstname: String,
    lastname: String,
    image: String,
    video: String,
    age: String,
    city: String,
    prize: String,
    capital: String,
    employees: String,
    lesson: String,
    position: String,
    prizetitle: String
  },
  methods: {
    getImage(slug){
      const baseUrl = process.env.BASE_URL
      return `${baseUrl}/content/${slug}.jpg`
    }
  }
}
</script>
<style lang="scss" scoped>
  h4{
    // font-family: 'Open Sans', sans-serif;
    // font-size: 1rem;
    // font-weight: bold;
    font-size: 2rem;
    padding: 0.5rem 0;
    font-style: italic;
  }
  .arrow{
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: 4;
    display: flex;
    align-items: center;
    opacity: 0;
    transition: all .3s;
    transition-delay: 1s;
    svg{
      width: 50px;
      height: 50px;
    }
    .odd &{
      right: 0;
      padding-right: 15px;
      background: linear-gradient(to left, rgba(black, 0.4), transparent);
    }
    .even &{
      left: 0;
      padding-left: 15px;
      background: linear-gradient(to right, rgba(black, 0.4), transparent);
    }
  }
  p.data{
    text-indent: 0;
    height: 3.6rem;
    padding: 0;
    overflow: hidden;
    transition: height .3s;
    transition-delay: 0.3s;
    line-height: 120%;
    font-size: 1rem;
    margin: 0;
    span{
      display: block;
    }
  }
  .playwrap{
    transition: all .3s;
    transition-delay: 0.7s;
    height: 0;
    padding: 0;
    opacity: 0;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    @media(max-width: 800px){
      opacity: 1;
      height: auto;
      margin-bottom: 0.5rem;
      padding-bottom: 0.2rem;
    }
  }
  span.lastname{
    display: block;
    transform: skewY(-8deg);
  }
  .firstname{
    font-family: 'Open Sans', sans-serif;
    font-weight: bold;
    text-transform: uppercase;
  }
  .description{
    margin-left: auto;
    margin-right: auto;
    font-size: 1rem;
    text-indent: 0;
    text-align: left;
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    background-color: #797979;
    border-top: 1.5rem solid #ff6804;
    display: none;
    padding: 1rem 2rem;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: all .3s;
    flex-direction: column;
    .even &{
      right: 100%;
    }
    .odd &{
      left: 100%;
    }

    p{
      font-size: 0.8rem;
      line-height: 120%;
      padding-bottom: 0.5rem;
      text-indent: 0;
    }
  }
  .article-item{
    &:hover{
      .arrow{
        opacity: 1;
        @media(max-width: 800px){
          display: none;
          opacity: 0;
        }
      }
      .playwrap{
        height: 70px;
        opacity: 1;
      }
      .data{
        height: 0;
      }
      z-index: 5;
      .description{
        display: flex;
        opacity: 1;
        @media(max-width: 800px){
          display: none;
          opacity: 0;
        }
      }
    }
  }

  .archive-item{
    &:hover{
      span.more{
        &:after{
          padding-left: 1rem;
        }
      }
      .mask{
        img{
          opacity: 1;
          transform: scale(1.008);
        }
      }
    }
  }
</style>